import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import { AnimationTrail } from 'shared/Animation/Animation'
import Layout from 'shared/Layout/Layout'
import Seo from 'shared/Seo/Seo'
import AnchorButton from 'shared/Button/AnchorButton'

interface Datas {
  flamelinkErrorContent: {
    slug: string
    title: string
    subtitle: string
    link: string
    text: string
    width: number
    height: number
    alt: string
    image: {
      url: string
    }[]
  }
}

const s = {
  container: `relative w-full h-screen`,
  wrapper: `max-w-screen-wrapper w-11/12 mx-auto`,

  content: `absolute top-2/4 -translate-y-2/4 z-2 w-w65 h-fit-content 
  smm:w-w50 smm:mt-6 xsx:w-w27`,
  title: `-mt-4 text-h1`,
  subtitle: `mb-20 text-clamp-3xl`,

  image: `absolute z-1 w-full hfull object-cover`,
}

const NotFoundPage = () => {
  const datas = useStaticQuery(graphql`
    query {
      flamelinkErrorContent {
        slug
        title
        subtitle
        link
        text
        width
        height
        alt
        image {
          url
        }
      }
    }
  `) as Datas

  const { title, subtitle, link, text, alt, width, height, image } =
    datas.flamelinkErrorContent

  return (
    <Layout backgrounds="transparent">
      <Seo title={title} description={subtitle} />
      <section className={s.container}>
        <img
          className={s.image}
          src={image[0].url}
          alt={alt}
          width={width}
          height={height}
        />

        <div className={s.wrapper}>
          <div className={s.content}>
            <AnimationTrail delay={300} x={0} y={0}>
              <h1 className={s.title}>{title}</h1>

              <p className={s.subtitle}>{subtitle}</p>

              <AnchorButton to={link} classname="">
                {text}
              </AnchorButton>
            </AnimationTrail>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default NotFoundPage
